export default "__VITE_ASSET__46d1ba2a__"